import {useNewUiEnabled, type UiVersion} from '@/composable/useNewUiEnabled'
import {watch, type MaybeRefOrGetter} from 'vue'

export function useNewUiBodyClass(isApp: boolean, localUiVersion?: MaybeRefOrGetter<UiVersion | undefined>) {
  const newUiEnabled = useNewUiEnabled(localUiVersion)

  watch(
    newUiEnabled,
    function (enabled) {
      document.body.dataset.uiVersion = enabled ? 'new' : 'legacy'
      document.body.classList.toggle('bg-white', enabled && isApp)
      document.body.classList.toggle('bg-new-neutral-0', enabled && !isApp)
      document.body.classList.toggle('text-new-neutral-700', enabled)
      document.body.classList.toggle('text-new-base', enabled)
      document.body.classList.toggle('bg-verylightgrey', !enabled)
    },
    {flush: 'sync', immediate: true}
  )
}
